import { createElement } from "react";
import React from "react";
import { MuiHelpers_createElement } from "../fable_modules/Feliz.MaterialUI.5.13.7-alpha.8/Mui.fs.js";
import { TableRow, Typography, TableSortLabel, TableCell } from "@mui/material";
import { empty, toArray, singleton, append, delay, toList } from "../fable_modules/fable-library-js.4.24.0/Seq.js";
import { reactApi } from "../fable_modules/Feliz.2.8.0/Interop.fs.js";
import { ctx as ctx_1 } from "../Context.js";
import { sortFn as sortFn_1, useResponsive } from "../Utils.js";
import { Tickets_toLocalizedSegment, Tickets_toLocalizedType, toDateStr, getLocale } from "../Locale.js";
import { Tickets_Severity_FromId_Z524259A4, Tickets_Severity, Tickets_TicketType_FromId_Z524259A4, Tickets_TicketStatus_FromId_Z524259A4, Tickets_Segment_FromId_Z524259A4, strIContains } from "../Shared/Shared.js";
import { join, isNullOrWhiteSpace } from "../fable_modules/fable-library-js.4.24.0/String.js";
import { safeHash, equals, int32ToString } from "../fable_modules/fable-library-js.4.24.0/Util.js";
import { map as map_1, singleton as singleton_1, contains } from "../fable_modules/fable-library-js.4.24.0/Array.js";
import { map, bind, defaultArg } from "../fable_modules/fable-library-js.4.24.0/Option.js";
import { ofArray, singleton as singleton_2 } from "../fable_modules/fable-library-js.4.24.0/List.js";
import { parse } from "../fable_modules/fable-library-js.4.24.0/Date.js";
import { RouterModule_nav } from "../fable_modules/Feliz.Router.4.0.0/Router.fs.js";
import { Tickets_SeverityChip_5E2CD6A8 } from "../Components/Tickets/SeverityChip.js";
import { utcStringToLocalDaySpan, tdMachines, tdVisibility, Table_td$0027 } from "../TicketHelpers.js";
import { Tickets_StatusChip_Z17F2D702 } from "../Components/Tickets/StatusChip.js";
import { Components_Table_Z1001F0B7 } from "../Components/Table.js";

export function Tickets_SortHeader_Z62C75220(tickets_SortHeader_Z62C75220InputProps) {
    const onClick = tickets_SortHeader_Z62C75220InputProps.onClick;
    const label = tickets_SortHeader_Z62C75220InputProps.label;
    const sortKey = tickets_SortHeader_Z62C75220InputProps.sortKey;
    const asc = tickets_SortHeader_Z62C75220InputProps.asc;
    const key = tickets_SortHeader_Z62C75220InputProps.$key;
    const isActive = key === sortKey;
    return MuiHelpers_createElement(TableCell, toList(delay(() => append(singleton(["classes.head", "table-cell-header"]), delay(() => append(singleton(["variant", "head"]), delay(() => append(asc ? singleton(["sortDirection", "asc"]) : singleton(["sortDirection", "desc"]), delay(() => {
        let elements;
        return singleton((elements = [MuiHelpers_createElement(TableSortLabel, toList(delay(() => append(singleton(["onClick", (ev) => {
            console.debug("Header on click", key);
            onClick(key);
        }]), delay(() => append(singleton(["active", isActive]), delay(() => append(asc ? singleton(["direction", "asc"]) : singleton(["direction", "desc"]), delay(() => singleton(["children", MuiHelpers_createElement(Typography, [["variant", "h6"], ["children", label]])]))))))))))], ["children", reactApi.Children.toArray(Array.from(elements))]));
    })))))))));
}

export function Tickets_Table_325F1C5E(tickets_Table_325F1C5EInputProps) {
    let children;
    const machineId = tickets_Table_325F1C5EInputProps.machineId;
    const customerId = tickets_Table_325F1C5EInputProps.customerId;
    const filter = tickets_Table_325F1C5EInputProps.filter;
    const tickets = tickets_Table_325F1C5EInputProps.tickets;
    const ctx = reactApi.useContext(ctx_1);
    const patternInput = reactApi.useState(false);
    const setAsc = patternInput[1];
    const asc = patternInput[0];
    const patternInput_1 = reactApi.useState("Date");
    const sortKey = patternInput_1[0];
    const patternInput_2 = reactApi.useState(0);
    const patternInput_3 = reactApi.useState(20);
    const responsive = useResponsive(undefined);
    const dateFnsLocale = getLocale(ctx.Language);
    const isBig = (responsive === "wideScreen") ? true : (responsive === "desktop");
    let patternInput_4;
    const matchValue = ctx.Session;
    if (matchValue != null) {
        const s = matchValue;
        patternInput_4 = [s.IsSuperAdmin ? true : s.IsAdmin, s.IsPtg];
    }
    else {
        patternInput_4 = [false, false];
    }
    const isAdminOrPtg = patternInput_4[0] ? true : patternInput_4[1];
    const handleSortChange = (newKey) => {
        if (sortKey === newKey) {
            setAsc(!asc);
        }
        else {
            setAsc(true);
        }
        patternInput_1[1](newKey);
    };
    const sorted = sortFn_1(asc, (sortKey === "Age") ? "Date" : sortKey)(tickets.filter((ticket) => {
        const containsTerm = (str_1) => strIContains(filter.SearchTerm, str_1);
        const segment = Tickets_Segment_FromId_Z524259A4(ticket.Segment);
        const status = Tickets_TicketStatus_FromId_Z524259A4(ticket.Status);
        const ticketType = Tickets_TicketType_FromId_Z524259A4(ticket.Type);
        const searched = isNullOrWhiteSpace(filter.SearchTerm) ? true : ((containsTerm(int32ToString(ticket.Id)) ? true : containsTerm(ticket.ShortDesc)) ? true : containsTerm(ticket.Customer.Name));
        const severitySelected = contains(ticket.CriticalOperationalHalt ? (new Tickets_Severity(0, [])) : Tickets_Severity_FromId_Z524259A4(ticket.Severity), filter.SelectedSeverities, {
            Equals: equals,
            GetHashCode: safeHash,
        });
        const isResponsible = defaultArg(bind((account) => map((sess) => (account.AccountId === sess.UserId), ctx.Session), ticket.Responsible), false);
        const ticketCustomerGroupInSelectedCompany = ticket.Customer.Groups.some((group) => defaultArg(map((company) => defaultArg(map((selectedId) => (selectedId === company.Id), filter.SelectedCompany), false), group.Company), false));
        const ticketInDepartment = defaultArg(map((departmentId) => equals(departmentId, ticket.DepartmentId), filter.SelectedDepartment), false);
        if ((((((searched && severitySelected) && (!filter.ResponsibleOnly ? true : isResponsible)) && contains(segment, filter.SelectedSegments, {
            Equals: equals,
            GetHashCode: safeHash,
        })) && contains(status, filter.SelectedStatus, {
            Equals: equals,
            GetHashCode: safeHash,
        })) && contains(ticketType, filter.SelectedTypes, {
            Equals: equals,
            GetHashCode: safeHash,
        })) && ((filter.SelectedCompany == null) ? true : ticketCustomerGroupInSelectedCompany)) {
            if (filter.SelectedDepartment == null) {
                return true;
            }
            else {
                return ticketInDepartment;
            }
        }
        else {
            return false;
        }
    }));
    const headers = toArray(delay(() => append(singleton(createElement(Tickets_SortHeader_Z62C75220, {
        key: "Severity",
        $key: "Severity",
        asc: asc,
        sortKey: sortKey,
        label: ctx.Locale.t("Ticket.Severity.Severity"),
        onClick: handleSortChange,
    })), delay(() => append(singleton(createElement(Tickets_SortHeader_Z62C75220, {
        key: "Date",
        $key: "Date",
        asc: asc,
        sortKey: sortKey,
        label: ctx.Locale.t("Date"),
        onClick: handleSortChange,
    })), delay(() => append(singleton(createElement(Tickets_SortHeader_Z62C75220, {
        key: "Id",
        $key: "Id",
        asc: asc,
        sortKey: sortKey,
        label: "#",
        onClick: handleSortChange,
    })), delay(() => append(isAdminOrPtg ? singleton(createElement(Tickets_SortHeader_Z62C75220, {
        key: "IsHidden",
        $key: "IsHidden",
        asc: asc,
        sortKey: sortKey,
        label: ctx.Locale.t("Ticket.Hidden"),
        onClick: handleSortChange,
    })) : empty(), delay(() => append(singleton(createElement(Tickets_SortHeader_Z62C75220, {
        key: "ShortDesc",
        $key: "ShortDesc",
        asc: asc,
        sortKey: sortKey,
        label: ctx.Locale.t("TicketList.Title"),
        onClick: handleSortChange,
    })), delay(() => append((customerId == null) ? singleton(createElement(Tickets_SortHeader_Z62C75220, {
        key: "Customer",
        $key: "Customer",
        asc: asc,
        sortKey: sortKey,
        label: ctx.Locale.t("Company"),
        onClick: handleSortChange,
    })) : empty(), delay(() => append((machineId == null) ? singleton(createElement(Tickets_SortHeader_Z62C75220, {
        key: "Machines",
        $key: "Machines",
        asc: asc,
        sortKey: sortKey,
        label: ctx.Locale.t("Machine"),
        onClick: handleSortChange,
    })) : empty(), delay(() => append(singleton(createElement(Tickets_SortHeader_Z62C75220, {
        key: "Status",
        $key: "Status",
        asc: asc,
        sortKey: sortKey,
        label: ctx.Locale.t("Ticket.Status.Status"),
        onClick: handleSortChange,
    })), delay(() => append(singleton(createElement(Tickets_SortHeader_Z62C75220, {
        key: "Type",
        $key: "Type",
        asc: asc,
        sortKey: sortKey,
        label: ctx.Locale.t("Ticket.TicketType.TicketType"),
        onClick: handleSortChange,
    })), delay(() => append(singleton(createElement(Tickets_SortHeader_Z62C75220, {
        key: "Segment",
        $key: "Segment",
        asc: asc,
        sortKey: sortKey,
        label: ctx.Locale.t("Ticket.Segment.Segment"),
        onClick: handleSortChange,
    })), delay(() => singleton(createElement(Tickets_SortHeader_Z62C75220, {
        key: "Age",
        $key: "Age",
        asc: asc,
        sortKey: sortKey,
        label: ctx.Locale.t("Ticket.Duration.Age"),
        onClick: handleSortChange,
    }))))))))))))))))))))))));
    const rows = (sorted.length === 0) ? singleton_1((children = singleton_2(MuiHelpers_createElement(TableCell, [["colSpan", headers.length], ["style", {
        textAlign: "center",
        fontStyle: "italic",
    }], ["size", "small"], ["children", ctx.Locale.t("TicketList.NoTickets")]])), MuiHelpers_createElement(TableRow, [["children", reactApi.Children.toArray(Array.from(children))]]))) : map_1((ticket_1) => {
        let elems_1;
        const status_1 = Tickets_TicketStatus_FromId_Z524259A4(ticket_1.Status);
        const created = parse(ticket_1.Date);
        const severity_1 = Tickets_Severity_FromId_Z524259A4(ticket_1.Severity);
        return MuiHelpers_createElement(TableRow, [["style", {
            cursor: "pointer",
            userSelect: "none",
        }], ["onClick", (_arg) => {
            RouterModule_nav(ofArray(["tickets", int32ToString(ticket_1.Id)]), 1, 1);
        }], (elems_1 = toList(delay(() => append(singleton(MuiHelpers_createElement(TableCell, [["variant", "body"], ["children", createElement("div", {
            style: {
                display: "flex",
            },
            children: createElement(Tickets_SeverityChip_5E2CD6A8, {
                severity: severity_1,
            }),
        })]])), delay(() => append(singleton(Table_td$0027(toDateStr(dateFnsLocale, created))), delay(() => append(singleton(Table_td$0027(int32ToString(ticket_1.Id))), delay(() => append(isAdminOrPtg ? singleton(tdVisibility(ctx.Locale, isBig, ticket_1.IsHidden)) : empty(), delay(() => append(singleton(MuiHelpers_createElement(TableCell, [["title", ticket_1.ShortDesc], ["className", join(" ", ["text-overflow"])], ["sx", {
            maxWidth: 40 + "ch",
        }], ["variant", "body"], ["children", ticket_1.ShortDesc]])), delay(() => append((customerId == null) ? singleton(Table_td$0027(ticket_1.Customer.Name)) : empty(), delay(() => append((machineId == null) ? singleton(tdMachines(ticket_1.Machines)) : empty(), delay(() => append(singleton(MuiHelpers_createElement(TableCell, [["variant", "body"], ["children", createElement("div", {
            style: {
                display: "flex",
            },
            children: createElement(Tickets_StatusChip_Z17F2D702, {
                status: status_1,
                readOnly: true,
            }),
        })]])), delay(() => append(singleton(Table_td$0027(Tickets_toLocalizedType(ctx.Locale, Tickets_TicketType_FromId_Z524259A4(ticket_1.Type)))), delay(() => append(singleton(Table_td$0027(Tickets_toLocalizedSegment(ctx.Locale, Tickets_Segment_FromId_Z524259A4(ticket_1.Segment)))), delay(() => singleton(Table_td$0027(`${utcStringToLocalDaySpan(ticket_1.Date, ctx.Locale)}`)))))))))))))))))))))))), ["children", reactApi.Children.toArray(Array.from(elems_1))])]);
    }, sorted);
    return createElement(Components_Table_Z1001F0B7, {
        headers: headers,
        rows: rows,
        stickyHeader: false,
    });
}

